import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'travelWillingness', standalone: true, pure: false })
export class TravelWillingnessPipe implements PipeTransform {
  private readonly keyMap: Record<string, string> = {
    'Ja': 'userlist.filter.travelYes',
    'Nein': 'userlist.filter.travelNo',
    'Eingeschränkt': 'userlist.filter.travelRestricted',
  };

  constructor(private translateService: TranslateService) {}

  transform(value: string): string {
    if (!value) return '';
    const key = this.keyMap[value] ?? value;
    return this.translateService.instant(key);
  }
}
